import React from "react";
import { DISPLAY_NAME_DROPDOWN_TOGGLE } from "./prodeseg-dropdown.constants";

export const ProdesegDropdownToggle: React.FC<{
    className?: string;
    children: React.ReactNode;
}> = ({ children, className }) => {
    return <div className={className}>{children}</div>;
};

ProdesegDropdownToggle.displayName = DISPLAY_NAME_DROPDOWN_TOGGLE;
